document.addEventListener('DOMContentLoaded', () => {
    
    // =====================================
    // 1. Инициализация библиотек (Lucide, AOS)
    // =====================================
    
    // Инициализация Lucide Icons
    if (typeof lucide !== 'undefined') {
        lucide.createIcons();
    }

    // Инициализация AOS (Animate On Scroll)
    if (typeof AOS !== 'undefined') {
        AOS.init({
            duration: 800,       // длительность анимации
            once: true,          // анимация только один раз
            mirror: false        // не повторять при обратной прокрутке
        });
    }


    // =====================================
    // 2. Функционал Хедера (Бургер-меню)
    // =====================================
    
    const burger = document.querySelector('.header__burger');
    const nav = document.querySelector('.header__nav');
    const navLinks = document.querySelectorAll('.header__link');

    burger.addEventListener('click', () => {
        const isActive = nav.classList.toggle('is-active');
        // Меняем иконку
        const icon = burger.querySelector('i');
        if (isActive) {
             icon.setAttribute('data-lucide', 'x');
        } else {
            icon.setAttribute('data-lucide', 'menu');
        }
        lucide.createIcons();
    });

    // Закрытие меню при клике на ссылку (для мобильных)
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            if (window.innerWidth <= 992) {
                nav.classList.remove('is-active');
                burger.querySelector('i').setAttribute('data-lucide', 'menu');
                lucide.createIcons();
            }
        });
    });


    // =====================================
    // 3. GSAP Анимация Hero Секции
    // =====================================
    const heroTitle = document.querySelector('.hero__title');
    
    if (heroTitle && typeof SplitType !== 'undefined' && typeof gsap !== 'undefined') {
        // 1. Разбиваем заголовок на слова
        const splitTitle = new SplitType(heroTitle, { types: 'words' });

        // 2. Устанавливаем начальное состояние (Скрыто и смещено)
        gsap.set(splitTitle.words, { 
            y: 20, 
            opacity: 0, 
            rotateX: -90 
        });

        // 3. Создаем анимацию заголовка
        gsap.to(splitTitle.words, {
            y: 0,
            opacity: 1,
            rotateX: 0,
            stagger: 0.05, 
            duration: 0.8,
            ease: "power3.out",
            delay: 0.5 
        });

        // 4. Анимация подзаголовка и кнопок
        gsap.from(".hero__subtitle", {
            opacity: 0,
            y: 30,
            duration: 0.8,
            delay: 1.5,
            ease: "power2.out"
        });

        gsap.from(".hero__actions a", {
            opacity: 0,
            y: 30,
            duration: 0.6,
            stagger: 0.15,
            delay: 1.8,
            ease: "power2.out"
        });
        
        // 5. Анимация визуального блока (плавное появление и скейл)
        gsap.from(".hero__image-wrapper", {
            opacity: 0,
            scale: 0.9,
            duration: 1,
            delay: 1.2,
            ease: "power3.out"
        });
    }


    // =====================================
    // 4. Анимация счетчика статистики (Innovation)
    // =====================================
    const statItems = document.querySelectorAll('.innovation__stat-number');

    if (statItems.length > 0) {
        
        // Функция для анимированного счета
        const countUp = (el) => {
            // Предотвращение повторной анимации
            if (el.hasAttribute('data-counted')) return;
            el.setAttribute('data-counted', 'true');
            
            const target = parseFloat(el.getAttribute('data-target'));
            const isFloat = target % 1 !== 0;
            const start = 0;
            const duration = 2000;
            let startTime = null;

            const animate = (timestamp) => {
                if (!startTime) startTime = timestamp;
                const progress = timestamp - startTime;
                const percentage = Math.min(progress / duration, 1);
                
                let current = start + percentage * (target - start);

                // Форматирование: если число с плавающей точкой, округляем до 1 знака
                if (isFloat) {
                    current = current.toFixed(1);
                } else {
                    current = Math.floor(current);
                }
                
                // Добавляем + или %
                let displayValue = current;
                if (el.textContent.includes('+') && !el.textContent.includes('%')) {
                    displayValue += '+';
                } else if (el.textContent.includes('%')) {
                    displayValue += '%';
                }

                el.textContent = displayValue;

                if (percentage < 1) {
                    requestAnimationFrame(animate);
                }
            };
            
            requestAnimationFrame(animate);
        };
        
        // Наблюдатель (Intersection Observer) для запуска анимации
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5 // Запуск, когда 50% элемента видно
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Элемент появился
                    const statGrid = entry.target.closest('.innovation__stats-grid');
                    statGrid.querySelectorAll('.innovation__stat-number').forEach(item => {
                        countUp(item);
                    });
                    // Отключаем наблюдателя после запуска
                    observer.unobserve(statGrid);
                }
            });
        }, observerOptions);
        
        // Наблюдаем за контейнером со статистикой
        const statsContainer = document.querySelector('.innovation__stats-grid');
        if (statsContainer) {
             observer.observe(statsContainer);
        }
    }


    // =====================================
    // 5. Функционал Контактной Формы
    // =====================================
    const contactForm = document.getElementById('contactForm');
    const successMessage = document.getElementById('successMessage');
    const formWrapper = document.querySelector('.contact__form-wrapper');

    let captchaResult = 0; // Переменная для хранения правильного ответа капчи

    // Функция для генерации капчи
    const generateCaptcha = () => {
        const num1 = Math.floor(Math.random() * 10) + 1;
        const num2 = Math.floor(Math.random() * 10) + 1;
        captchaResult = num1 + num2;
        document.querySelector('.captcha-label').textContent = `Сколько будет ${num1} + ${num2}?`;
    };

    // Функция для очистки ошибок
    const clearError = (input) => {
        // Проверка на input, так как для чекбокса input.name не подойдет для div
        const name = input.type === 'checkbox' ? input.id : input.name;
        input.classList.remove('is-error');
        const errorElement = document.querySelector(`[data-error-for="${name}"]`);
        if (errorElement) {
             errorElement.textContent = '';
        }
    };

    // Функция для показа ошибки
    const showError = (input, message) => {
        const name = input.type === 'checkbox' ? input.id : input.name;
        input.classList.add('is-error');
        const errorElement = document.querySelector(`[data-error-for="${name}"]`);
        if (errorElement) {
            errorElement.textContent = message;
        }
    };

    // Функция валидации
    const validateForm = () => {
        let isValid = true;
        const inputs = contactForm.querySelectorAll('input[required]');

        inputs.forEach(input => {
            clearError(input);

            if (input.type === 'text' || input.type === 'tel' || input.type === 'email') {
                if (input.value.trim() === '') {
                    showError(input, 'Это поле обязательно для заполнения.');
                    isValid = false;
                }
            }
        });

        // 1. Валидация Имени 
        const nameInput = document.getElementById('name');
        if (nameInput.value.trim() !== '' && nameInput.value.trim().length < 2) {
            showError(nameInput, 'Имя должно содержать не менее 2 символов.');
            isValid = false;
        }


        // 2. Валидация Email
        const emailInput = document.getElementById('email');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailInput.value.trim() !== '' && !emailRegex.test(emailInput.value.trim())) {
            showError(emailInput, 'Введите корректный Email адрес.');
            isValid = false;
        }

        // 3. Валидация Телефона 
        const phoneInput = document.getElementById('phone');
        const phoneRegex = /^\+?[\d\s]{7,15}$/; 
        if (phoneInput.value.trim() !== '' && !phoneRegex.test(phoneInput.value.trim())) {
            showError(phoneInput, 'Введите корректный номер телефона (можно с пробелами и "+").');
            isValid = false;
        }
        
        // 4. Валидация Капчи
        const captchaInput = document.getElementById('captcha');
        if (parseInt(captchaInput.value.trim()) !== captchaResult) {
            showError(captchaInput, 'Неправильный ответ на математический пример.');
            isValid = false;
        }
        
        // 5. Валидация Согласия
        const consentInput = document.getElementById('consent');
        if (!consentInput.checked) {
            showError(consentInput, 'Вы должны дать согласие на обработку данных.');
            isValid = false;
        }

        return isValid;
    };

    // Инициализация капчи при загрузке
    generateCaptcha();

    // Обработчик отправки формы
    contactForm.addEventListener('submit', function(e) {
        e.preventDefault();

        if (validateForm()) {
            // Имитация AJAX-отправки
            const formData = new FormData(this);
            console.log('Данные формы:', Object.fromEntries(formData.entries()));

            // Скрываем форму и показываем сообщение об успехе
            contactForm.style.display = 'none';
            successMessage.style.display = 'block';

            // Очистка формы и генерация новой капчи
            this.reset();
            generateCaptcha(); 
        } else {
            // Если валидация не пройдена, прокручиваем к первому полю с ошибкой
            const firstError = document.querySelector('.form-input.is-error');
            if (firstError) {
                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    });
// =====================================
    // 6. Cookie Popup Logic
    // =====================================
    const cookiePopup = document.getElementById('cookiePopup');
    const cookieAcceptBtn = document.getElementById('cookieAccept');

    // Проверяем, есть ли запись в localStorage
    if (!localStorage.getItem('cookieAccepted')) {
        // Если нет, показываем попап с задержкой 2 секунды
        setTimeout(() => {
            cookiePopup.classList.add('is-visible');
        }, 2000);
    }

    // Обработка клика по кнопке
    if (cookieAcceptBtn) {
        cookieAcceptBtn.addEventListener('click', () => {
            // Сохраняем согласие
            localStorage.setItem('cookieAccepted', 'true');
            // Скрываем попап
            cookiePopup.classList.remove('is-visible');
        });
    }
});